import React from 'react'

export type TableProps = React.HTMLAttributes<HTMLTableElement>

const Table = React.forwardRef<HTMLTableElement, TableProps>(
  ({ children, className }, ref) => {
    return (
      <div
        ref={ref}
        className={`overflow-hidden border border-solid divide-y divide-gray-200 rounded-lg border-gray ${className}`}
      >
        <table className="min-w-full">{children}</table>
      </div>
    )
  }
)

export default Table
